import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "./soothing-theme.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Header from "./components/Header";
import IndividualTherapy from "./pages/ClinicalServices/IndividualTherapy";
import CoupleTherapy from "./pages/ClinicalServices/CoupleTherapy";
import DBT from "./pages/ClinicalServices/DBT";
import PsychodiagnosticAssessments from "./pages/ClinicalServices/PsychodiagnosticAssessments";
import ADHD from "./pages/ClinicalServices/ADHD";
import Consultation from "./pages/ClinicalServices/Consultation";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".fade-in");
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          el.classList.add("visible");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  return (
    <div className="app-root">
      <ScrollToTop />
      <Header />
      <main className="content-wrapper">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 2 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route
                path="/services/individual-therapy"
                element={<IndividualTherapy />}
              />
              <Route
                path="/services/couple-therapy"
                element={<CoupleTherapy />}
              />
              <Route path="/services/dbt" element={<DBT />} />
              <Route
                path="/services/psychodiagnostic"
                element={<PsychodiagnosticAssessments />}
              />
              <Route path="/services/adhd" element={<ADHD />} />
              <Route path="/services/consultation" element={<Consultation />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
};

export default App;
